const basePath = "https://portal.azure.com/#blade/Microsoft_Azure_ContainerService/AksK8ResourceMenuBlade/overview-Deployment/aksClusterId";
const requiredParams = ["subscriptionId", "resourceGroup", "clusterName"];
class AksClusterLinksFormatter {
  async formatClusterLink(options) {
    if (!options.dashboardParameters) {
      throw new Error("AKS dashboard requires a dashboardParameters option");
    }
    const args = options.dashboardParameters;
    for (const param of requiredParams) {
      if (typeof args[param] !== "string") {
        throw new Error(
          `AKS dashboard requires a "${param}" of type string in the dashboardParameters option`
        );
      }
    }
    const path = `/subscriptions/${args.subscriptionId}/resourceGroups/${args.resourceGroup}/providers/Microsoft.ContainerService/managedClusters/${args.clusterName}`;
    const { name, namespace, uid } = options.object.metadata;
    const { selector } = options.object.spec;
    const params = {
      kind: options.kind,
      metadata: { name, namespace, uid },
      spec: {
        selector
      }
    };
    return new URL(
      `${basePath}/${encodeURIComponent(path)}/resource/${encodeURIComponent(
        JSON.stringify(params)
      )}`
    );
  }
}

export { AksClusterLinksFormatter };
//# sourceMappingURL=AksClusterLinksFormatter.esm.js.map
